/*
 * DEPRICATED (no longer used)
 */


import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { isAuthenticated } from '../auth';
import { Link, Redirect, useHistory } from 'react-router-dom';
import ShowPrimaryPhoto from './ShowPrimaryPhoto';
import { startTrade } from './apiCore';
import ChooseItemCard from './ChooseItemCard';
import { getUserInfo, deleteProduct, getMyListedItems } from '../user/apiUser';
import { sendNotification } from './sendNotification';

const Card = ({listing, activeTrades}) => {
    const history = useHistory()
    const [isListed, setIsListed] = useState('false');
    const [id, setId] = useState('');  //user id
    const [token, setToken] = useState('');
    
    const [myItems, setMyItems] = useState([]);
    const [chosenItems, setChosenItems] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [itemsLoading, setItemsLoading] = useState(false);

    //states for modals
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showStart, setShowStart] = useState(false); //Start Trade Modal
    const handleCloseStart = () => {
        setChosenItems([]);
        setShowStart(false);
    };

    const handleShowStart = () => {
        if (isAuthenticated()) {
            setShowStart(true);
        }
        else {
            history.push('/signin');
        }
    }

    useEffect(() => {
        console.log(listing);
        console.log('listing');
        if(isAuthenticated()) {
            const { user: {_id}, token } = isAuthenticated();
            setId(_id);
            setToken(token);
        }
    },[]); 
    

    const showLoading = () => itemsLoading  && (
        <div className='alert'>
            <h2> Loading... </h2>
        </div>
    );

    const getMyItems = () => {
        setItemsLoading(true);
        getMyListedItems(id, token).then(data => {
            setItemsLoading(false);
            setMyItems(data);
            //populate isSelected array with false
            data.forEach((_) => setIsSelected(isSelected.concat(false)));
        });
    };
    const handleClick = (item, i) => {
        if (isSelected[i]){
            console.log('removing item');
            setChosenItems(chosenItems.filter(currentItem => currentItem !== item._id));
            isSelected[i] = false;
            setIsSelected(isSelected);
        }
        else {
            setChosenItems(chosenItems.concat(item._id));
            isSelected[i] = true;
            setIsSelected(isSelected);
        }
    }

    const handleSubmit = () => {
        const startTradeData = {productIds: chosenItems, senderId: id}
        console.log(startTradeData);

        startTrade(startTradeData, listing, token).then(data => {
            history.push('/user/trades');
        });

        //send notification
        const { user: {_id} } = isAuthenticated()
        getUserInfo(_id).then(data => {
            const { name } = data;
            sendNotification('trade','',`New Trade from ${name}`, 'Click to go to trade offer', ``, '/user/trades',_id, listing.userId);
        });
    };

    const startTradeModal = () => (
        <Modal
        show={showStart}
        onShow={getMyItems} //replace with get my Items
        onHide={handleCloseStart}
        size='lg'
        centered
        >
            <Modal.Header closeButton>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Choose Item(s) to Trade
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className='row'>
                    <div className='col-8'>
                        <div className='row'>
                            {showLoading()}
                            {myItems.map((item, i) => (
                                <div onClick={() => handleClick(item,i)}>
                                    <ChooseItemCard selected={isSelected[i]}key={i} listing={item} itemToTrade={listing}/>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button onClick={handleSubmit}className='btn btn-warning'>Next</button>
            </Modal.Footer>
           
        </Modal>

    );


    const handleDelete = () => {
        deleteProduct(listing._id, id, token);
        handleClose();
        window.location.reload(false);
    };

    const deleteModal = () => (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>Remove Listing </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p> Are you sure you want to remove this item? </p>
            </Modal.Body>

            <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>Cancel</Button>
                <Button variant='danger' onClick={handleDelete}>Permanantly Delete</Button>
            </Modal.Footer>
        </Modal>
    );

    const isMyListingButtons = () => ( //listing shows up different if its the users own
    <div>
        <Link to={{pathname: `/edit/${listing._id}/${listing.userId}`}}>
            <button className='btn btn-outline-primary mt-2 mb-2 mr-2'>
                Edit Listing
            </button>
        </Link>

        <button onClick={handleShow}className='btn btn-outline-primary mt-2 mb-2 mr-2'>
            Remove Options
        </button>
    </div>
    )

    const isListedButtons = () => {
         //check if item is being traded
        /*
        if (activeTrades)  {
            activeTrades.map(trade => {
                if (listing._id === trade.recieverItem) {
                    setIsTrading(true);
                }
            })
        }
        */ 
        let isTrading = false;
        if (activeTrades) {
            activeTrades.map(trade => {
                if (listing._id === trade.recieverItem || listing._id === trade.senderItem) {
                    isTrading = true;
                }
            });
        }
        return (
            <div>
                 <Link to={`/loot/${listing._id}`}>
                    <button className='btn btn-outline-primary mt-2 mb-2 mr-2'>
                        View Listing
                    </button>


                </Link>
                {isTrading ? (
                    <button className='btn btn-outline-secondary mt-2 mb-2 mr-2'>
                        Already Trading
                    </button>
                )
                :( 
                    <button onClick={handleShowStart}className='btn btn-outline-primary mt-2 mb-2 mr-2'>
                        Start Trade
                    </button>

                )
                }
            </div>
        );
    };

    return (
        <div className='col-4 mb-3'>
            {deleteModal()}
            {startTradeModal()}
            <div className='card'>
                <div className='card-header'>{listing.name}</div>
                <div className='card-body'> 
                    <ShowPrimaryPhoto product={listing}/>
                    <p>{listing.description.substring(0,100)} </p>
                    <p>${listing.price}</p>

                    {isAuthenticated() && listing.userId === id ? <div> {isMyListingButtons()}</div> : <div>{isListedButtons()}</div>}
                </div>
            </div>
        </div>
    );
};

export default Card;
